// Generated by scripts/generate-icons.ts
/* eslint-disable */

// This file is auto-generated. Do not edit manually.
import React from 'react';
import { BaseIcon } from '../src/components/BaseIcon';
import type { IconDefinition, IconPath } from '../src/types/IconData.types';

const iconData: IconDefinition = {
  name: "ChevronDown",
  viewBox: "0 0 25 20",
  paths: [
    {
      d: "M6.117 7.11a.417.417 0 0 1 .562 0L12 12.1l5.32-4.99a.417.417 0 0 1 .564 0 .357.357 0 0 1 0 .527l-5.603 5.254A.4.4 0 0 1 12 13a.4.4 0 0 1-.281-.11L6.117 7.638a.357.357 0 0 1 0-.528"
    }
  ]
};

export const ChevronDownIcon: React.FC<React.SVGProps<SVGSVGElement> & { iconPathClassName?: string }> = (props) => {
  return <BaseIcon icon={iconData} {...props} />;
};
